module.exports = __webpack_public_path__ + "static/media/logo-backoffice.6453ec04.svg";